module.exports = __webpack_public_path__ + "static/media/casino.42e7c6c3.svg";